<!-- <select #langSelect (change)="switch(langSelect.value)">
  <option value="en">English</option>
  <option value="ar">العربية</option>
</select> -->
<!-- To change language uncomment code -->

<router-outlet></router-outlet>
